module.exports = __webpack_public_path__ + "front/img/8.4e16a3a1.png";